var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuthentication(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 200,
    viewBox: "0 0 218 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_125_6760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.14478 49.4666V144.112C1.14478 146.054 2.18294 147.861 3.87476 148.823L83.1019 194.579C84.7937 195.559 86.87 195.559 88.5426 194.579L167.77 148.823C169.462 147.842 170.5 146.054 170.5 144.112V49.4666L85.8127 98.3563L1.14478 49.4666Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.14502 49.4667L85.8321 0.576904L170.519 49.4667L85.8321 98.3756L1.14502 49.4667Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8469 68.3648L118.515 19.4751L137.586 30.4911L52.8991 79.4001L52.8606 116.005L33.8276 105.027L33.8469 68.3648Z",
    fill: "#0C57BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.832 98.3755V194.848",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6047 158.935V175.103L44.4785 157.974V141.805L73.6047 158.935Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.582 200.165C195.861 200.165 217.165 178.861 217.165 152.582C217.165 126.303 195.861 105 169.582 105C143.303 105 122 126.303 122 152.582C122 178.861 143.303 200.165 169.582 200.165Z",
    fill: "#F46E56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 132V156.244",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 172.875H170.058",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_125_6760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 217.303,
    height: 200,
    fill: "white",
    transform: "translate(0.568115)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthentication);
export default __webpack_public_path__ + "static/media/authentication.c7fd773005b527e34470450caba6abf5.svg";
export { ForwardRef as ReactComponent };